import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import * as kestrelEmbedCode from "shared/kestrel-embed-code";
import * as yup from "yup";
import { validate } from "shared/yup";
import { getAgentsWithLeads } from "redux/selector";
import { WidgetConfigLayout } from "../widget-config-layout";
import { WidgetFieldGrid, WidgetFieldCell, WidgetSelect } from "../widget-fields";
import { getUser } from "redux/selector";

const mapStateToProps = (state: RootState) => {
	return {
		user: getUser(state),
		agents: getAgentsWithLeads(state),
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

interface Props extends 
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps> {
}

interface State {
	agentId: string;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props) 
		this.state = {
			agentId: "",
		}
	}

	private validationSchema = {
		agentId: yup
			.string()
			.required("Agent is required.")
	};

	public render() {
		const { user, agents } = this.props;
		const { agentId } = this.state;
		const errors = validate(this.validationSchema, this.state);
		const embedCode = kestrelEmbedCode.agentListingWidget(
			user.websitePlatform,
			parseInt(agentId),
		);
		return (
			<WidgetConfigLayout user={user} embedCode={!errors ? embedCode : undefined}>
				<WidgetFieldGrid>
					<WidgetFieldCell full>
						<WidgetSelect
							label="Agent"
							required
							value={agentId}
							options={agents.map((agent) => ({value: agent.id, label: agent.name}))}
							onChange={(value) => this.setState({agentId: value})}
						/>
					</WidgetFieldCell>
				</WidgetFieldGrid>
			</WidgetConfigLayout>
		);
	}
}

export const AgentListingsConfig = connect(mapStateToProps, mapDispatchToProps)(Component);